module.exports = __webpack_public_path__ + "static/media/battery_level_2_icon.eab7ae05.svg";